// toggle class when page is scrolled
const { body } = document;
const header = document.getElementById('header');
let lastScrollPosition = 0;

const setScrollingClass = () => {
  const windowScrollY = window.scrollY;
  // prevent toggling the "scroll" event when we open navigation.
  if (lastScrollPosition && windowScrollY === 0) {
    return;
  }

  const isScrolling = windowScrollY > header.offsetTop + 100;
  // add general scrolling class to the body
  body.classList.toggle('scrolling', isScrolling);

  // check for scroll direction
  if (windowScrollY > lastScrollPosition) {
    // when scrolling down
    if (body.classList.contains('scrolling--top') && lastScrollPosition !== 0) {
      body.classList.remove('scrolling--top');
    }
  } else if (lastScrollPosition - windowScrollY > 30 && windowScrollY !== 0) {
    // when scrolling up
    body.classList.add('scrolling--top');
  }
  // update latest scroll position
  lastScrollPosition = Math.max(0, windowScrollY);
};

window.addEventListener('scroll', setScrollingClass);

document.addEventListener('DOMContentLoaded', () => setScrollingClass());
